import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import './Casestudy.css';

const Casestudy = () => {
  const [caseStudies, setCaseStudies] = useState([]);

  useEffect(() => {
    const fetchCaseStudies = async () => {
      try {
        const response = await fetch('https://api.ndtechland.com/api/HomeApi/GetCaseStudies');
        const data = await response.json();

        if (data.status === 200) {
          setCaseStudies(data.data);
        } else {
          console.error('Failed to fetch case studies:', data.message);
        }
      } catch (error) {
        console.error('Error fetching case studies:', error);
      }
    };

    fetchCaseStudies();
  }, []);

  return (
    <>
      <Header />

      <section className="casestudy-section">
        <div className="container">
          <div className="section-head text-center">
            <h4><span>Our Case Studies</span></h4>
            <p className="section-description">
              Discover how N D Connect has transformed businesses across industries. Explore our case studies to see the real-world impact of our platform.
            </p>
          </div>

          <div className="row g-4">
            {caseStudies.map((study) => (
              <div key={study.id} className="col-12 col-md-6 col-lg-4">
                <div className="case-study-card">
                  <div className="case-study-img-wrap">
                    <img
                      src={`https://api.ndtechland.com/image/${study.image}`}
                      className="case-study-img"
                      alt={study.title}
                    />
                    <div className="case-study-badge">Case Study</div>
                  </div>
                  <div className="case-study-content">
                    <h5 className="case-study-card-title">{study.title}</h5>
                    <div
                      className="case-study-card-desc"
                      dangerouslySetInnerHTML={{ __html: study.description }}
                    />
                    <Link to={`/Casestudydetails/${study.id}`} className="case-study-btn">
                      <span>Read More</span>
                      <FaArrowRight className="case-study-btn-icon" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Casestudy;
